<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <Login :drawer="openLogin"/>
  </div>
</template>

<script>
import eventBus from '@/utils/event-bus'
import Login from '@/views/login/login'
export default {
  name: 'App',
  components: {Login},
  data(){
    return{
      openLogin:false
    }
  },
  mounted(){
    // document.title="模板详情"
    eventBus.$on('openLogin',()=>{
      this.openLogin = true
    })
    eventBus.$on('closedLogin',()=>{
      this.openLogin = false
    })
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  min-width: 300px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue